<script>
  // @ts-nocheck

  import { CATEGORIES_COLORS } from '$lib/constants/categories';
  import { formatNumber } from '$lib/utils/stat';
  import { getRetrieveMediaUrl } from '$lib/utils/clientStorage';

  export let imageSrc = '';
  export let name = '';
  export let link = '';
  export let description = '';
  export let categories = [];
  export let creatorName = '';
  export let favoritesCount = 0;
</script>

<article class="group">
  <a data-sveltekit-reload href={link} class="outline-none">
    {#if imageSrc}
      <img
        alt="Preview"
        class="h-40 w-full rounded-xl object-cover transition"
        src={getRetrieveMediaUrl(imageSrc)}
        onerror="this.src ='/no-preview.jpg';"
      />
    {/if}

    <div class="py-4">
      <div class="flex items-start">
        <div class="flex-1">
          <h3 class="text-sm font-medium text-indigo-500 line-clamp-3">
            {name}
          </h3>
        </div>

        {#if favoritesCount}
          <div class="flex items-center text-gray-600 py-1 ml-2">
            <p class="text-xs mr-1">{formatNumber(favoritesCount)}</p>
            <svg
              class="-ml-0.5 h-4 w-4 fill-red-400"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
              />
            </svg>
          </div>
        {/if}
      </div>

      {#each categories as category}
        <span
          class={`inline-block mt-1 text-[#444444] text-[10px]/relaxed bg-[${CATEGORIES_COLORS[category]}] pt-[2px] pb-[2px] pr-1 pl-1 rounded mr-1`}
        >
          {category}
        </span>
      {/each}

      <p class="mt-2 line-clamp-3 text-xs text-gray-500">
        {description}
      </p>
      {#if creatorName}
        <span class="text-xs"> by {creatorName} </span>
      {/if}
    </div>
  </a>
</article>
